// Client-side validation for the auth screens, with clear Arabic messages.
// Rules mirror the backend (auth/signup, auth/login) so users get an
// immediate, understandable message instead of a generic server rejection.

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
export const PASSWORD_MIN_LENGTH = 8

export const AUTH_MESSAGES = {
  emailRequired: 'يرجى إدخال بريدك الإلكتروني',
  emailInvalid: 'يرجى إدخال بريد إلكتروني صحيح، مثال: name@example.com',
  passwordRequired: 'يرجى إدخال كلمة المرور',
  passwordShort: `يجب أن تكون كلمة المرور ${PASSWORD_MIN_LENGTH} أحرف على الأقل`,
  nameRequired: 'يرجى إدخال اسمك الكامل',
  nameShort: 'يجب أن يكون الاسم حرفين على الأقل',
  phoneInvalid: 'يرجى إدخال رقم هاتف صحيح',
  confirmRequired: 'يرجى إعادة إدخال كلمة المرور للتأكيد',
  passwordsMismatch: 'كلمتا المرور غير متطابقتين',
  emailTaken: 'هذا البريد الإلكتروني مسجّل بالفعل. جرّب تسجيل الدخول بدلاً من ذلك.',
  generic: 'يرجى مراجعة البيانات المُدخلة والمحاولة مرة أخرى',
}

const isValidEmail = (email) => EMAIL_REGEX.test(email)

const isValidPhone = (phone) => {
  const digits = phone.replace(/[^0-9]/g, '')
  return digits.length >= 8 && digits.length <= 15 && /^\+?[0-9\s-]+$/.test(phone)
}

export function validateLoginForm({ email, password }) {
  const errors = {}
  const trimmedEmail = (email || '').trim()

  if (!trimmedEmail) errors.email = AUTH_MESSAGES.emailRequired
  else if (!isValidEmail(trimmedEmail)) errors.email = AUTH_MESSAGES.emailInvalid

  if (!password) errors.password = AUTH_MESSAGES.passwordRequired

  return errors
}

export function validateRegisterForm({ name, email, phone, password, password_confirmation }) {
  const errors = {}
  const trimmedName = (name || '').trim()
  const trimmedEmail = (email || '').trim()
  const trimmedPhone = (phone || '').trim()

  if (!trimmedName) errors.name = AUTH_MESSAGES.nameRequired
  else if (trimmedName.length < 2) errors.name = AUTH_MESSAGES.nameShort

  if (!trimmedEmail) errors.email = AUTH_MESSAGES.emailRequired
  else if (!isValidEmail(trimmedEmail)) errors.email = AUTH_MESSAGES.emailInvalid

  // Phone is optional; validate only when provided.
  if (trimmedPhone && !isValidPhone(trimmedPhone)) errors.phone = AUTH_MESSAGES.phoneInvalid

  if (!password) errors.password = AUTH_MESSAGES.passwordRequired
  else if (password.length < PASSWORD_MIN_LENGTH) errors.password = AUTH_MESSAGES.passwordShort

  if (!password_confirmation) errors.password_confirmation = AUTH_MESSAGES.confirmRequired
  else if (password !== password_confirmation) errors.password_confirmation = AUTH_MESSAGES.passwordsMismatch

  return errors
}

// Map Laravel 422 field errors ({ field: [msg, ...] }) to clear Arabic messages.
export function mapServerFieldErrors(serverErrors) {
  if (!serverErrors || typeof serverErrors !== 'object') return {}

  const mapped = {}
  for (const [field, messages] of Object.entries(serverErrors)) {
    const raw = Array.isArray(messages) ? messages.join(' ') : String(messages)
    const lower = raw.toLowerCase()

    switch (field) {
      case 'email':
        mapped.email =
          lower.includes('taken') || lower.includes('already') ||
          lower.includes('unique') || lower.includes('exists')
            ? AUTH_MESSAGES.emailTaken
            : AUTH_MESSAGES.emailInvalid
        break
      case 'password':
        mapped.password = AUTH_MESSAGES.passwordShort
        break
      case 'name':
        mapped.name = AUTH_MESSAGES.nameRequired
        break
      case 'phone':
        mapped.phone = AUTH_MESSAGES.phoneInvalid
        break
      default:
        mapped[field] = raw
    }
  }
  return mapped
}

export const hasErrors = (errors) => Object.keys(errors || {}).length > 0
